import styled from 'styled-components';
import { Headline, Body } from '@cambridgeassessment/cambridge-ui';
import { blissPro, sourceSansPro } from '@cambridgeassessment/cambridge-ui/build/abstracts/constants';

export const SeriesSelectContainer = styled.div`
  padding-top: 64px;
  width: 67%;
  margin: auto;
`;

export const StyledHeadline = styled(Headline)`
  font-family: ${blissPro};
  font-size: 46px;
  font-weight: bold;
  line-height: 1.5;
  padding-bottom: 16px;
`;

export const StyledHeader = styled.h2`
  font-family: ${blissPro};
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 16px;
`;

export const StyledBody = styled(Body)`
  font-family: ${sourceSansPro};
  font-size: 20px;
  line-height: 1.5;
`;

export const StyledDropdownContainer = styled.div`
  max-width: 464px;
  padding-top: 32px;

  .MuiButton-contained {
    margin-top: 32px;
  }
`;
